/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createIataCodeFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type IataCode, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Iata
 */
export interface IataRequestBuilder extends BaseRequestBuilder<IataRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<IataCode[]>}
     * @throws {ProblemDetails} error when the service returns a 401 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<IataCode[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const IataRequestBuilderUriTemplate = "{+baseurl}/Iata";
/**
 * Metadata for all the requests in the request builder.
 */
export const IataRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: IataRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createIataCodeFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
